// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "./context/AuthContext";
import { AccountProvider } from "./context/AccountContext";
import App from "./App";          // we will create App next
import AppErrorBoundary from "./components/AppErrorBoundary";
import "./index.css";
import MarketingPreview from "./marketing/MarketingPreview";
import { installGlobalChunkLoadErrorRecovery } from "./utils/chunkLoadRecovery";

const root = ReactDOM.createRoot(document.getElementById("root"));

installGlobalChunkLoadErrorRecovery();

const forceMarketingOnly = process.env.REACT_APP_MARKETING_ONLY === "true";
const isMarketingPreview =
  forceMarketingOnly ||
  window.location.pathname.startsWith("/marketing-preview");

root.render(
  <AppErrorBoundary>
    {isMarketingPreview ? (
      <MarketingPreview />
    ) : (
      <AuthProvider>
        <AccountProvider>
          <App />
        </AccountProvider>
      </AuthProvider>
    )}
  </AppErrorBoundary>
);
